import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://voltechpowersolutions.in";
const DEFAULT_OG =
  "https://customer-assets.emergentagent.com/job_86e8291b-4621-4191-9355-412a5a7abfe4/artifacts/h0kzwlik_1656007966754%20%281%29.png";

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  keywords,
}) {
  const fullTitle = title
    ? `${title} · VOLTECH POWER SOLUTIONS`
    : "VOLTECH POWER SOLUTIONS · Lithium Batteries, Solar Street Lights, EV & CSR · Hyderabad";
  const url = `${SITE_URL}${path}`;
  const desc =
    description ||
    "VOLTECH POWER SOLUTIONS (VPS) — Hyderabad-based manufacturer of lithium-ion batteries, solar street lights, electric vehicles and CSR-led energy infrastructure. GSTIN 36AATFV5997N1ZQ.";
  const kw =
    keywords ||
    "lithium battery manufacturer Hyderabad, LiFePO4 battery pack, solar street light supplier, EV battery manufacturer, electric vehicle assembling, CSR energy projects India, traffic signal battery, weighing scale battery, custom battery pack, 2 wheeler 3 wheeler EV battery, pole fabrication, inverters Hyderabad";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="VOLTECH POWER SOLUTIONS" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
}
